import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../partnerAuth';

// Client-side gate only — convenience, not security. Every /partner/* API call is
// independently authorized server-side against the verified Cognito JWT, so bypassing
// this in devtools reveals nothing.
export default function ProtectedPartnerRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/partner/login" replace />;
}
